import { Navigate, createFileRoute } from "@tanstack/react-router";

import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute("/_private/record-labelling-admin/$")({
  staticData: ROUTE_STATIC.recordLabellingAdmin,
  component: () => <Navigate to="/record-labelling-admin/projects" replace />,
});
